export enum QueryKeys {
  Deliveries = 'deliveries',
  Delivery = 'delivery',
  TimeStamps = 'timeStamps',
  SurgeryTimeStamps = 'surgeryTimeStamps',
  SearchDeliveries = 'searchDeliveries',
  Suppliers = 'suppliers',
  Surgeons = 'surgeons',
  DeviceReps = 'deviceReps',
  Orders = 'orders',
  AllOrders = 'allOrders',
  AllOrdersHospitals = 'allOrdersHospitals',
  ValidateOrders = 'validateOrders',
  SearchOrders = 'searchOrders',
  Order = 'order',
  CurrentUser = 'currentUser',
  LastDmInspectionParams = 'lastDmInspectionParams',
  Implants = 'implants',
  SetManuals = 'setManuals',
  DownloadUrlFromGS = 'downloadUrlFromGS',
  GetGS1ImplantData = 'getGS1ImplantData',
  SadlSet = 'sadlSet',
  TrayCapturePrintOut = 'trayCapturePrintOut',
  TurnaroundList = 'turnaroundList',
  SurgeryAttachments = 'surgeryAttachments',
  QuickSwitchUsers = 'quickSwitchUsers',
  LocationAliases = 'locationAliases',
  Locations = 'locations',
  SmartwaysLocations = 'smartwaysLocations',
  Tenants = 'tenants',
  UnrecognisedSurgeons = 'unrecognisedSurgeons',
  HospitalSurgeons = 'hospitalSurgeons',
}
